<div class="d-flex table-select-container">
  <div>
    <button
      [ngClass]="
        selectedOverview === 'print'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('print')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'print'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countPrint }}"
        [matBadgeHidden]="countPrint == null || countPrint === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Printwerk
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'text'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('text')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'text' ? 'border-badge-selected' : 'border-badge'
        "
        matBadge="{{ countText }}"
        [matBadgeHidden]="countText == null || countText === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Teksten
    </button>
  </div>
</div>

<print-immo-overview
  *ngIf="selectedOverview === 'print'"
  (countChange)="updatePrintCount($event)"
>
</print-immo-overview>
<text-immo-overview
  *ngIf="selectedOverview === 'text'"
  (countChange)="updateTextCount($event)"
>
</text-immo-overview>
